import { render } from "./Profile.vue?vue&type=template&id=243dc195&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=243dc195&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243dc195"]])

export default __exports__